import React from 'react';
import { Users, Edit, X } from 'lucide-react';
import { Button } from '../ui/button';
import CareTeamEditor from '../CareTeamEditor';

const CareTeamSection = ({ editedData, isEditing, onToggleEdit, onCancelEdit, onCareTeamChange }) => {
  return (
    <div className="mb-6">
      <div className="card border-2 border-blue-200 bg-gradient-to-br from-white to-blue-50 shadow-lg">
        <div className="flex items-center justify-between mb-4 pb-2 border-b-2 border-blue-100">
          <h2 className="text-xl font-semibold text-slate-900 flex items-center gap-2">
            <Users size={20} className="text-blue-600" />
            Care Team
          </h2>
          {!isEditing ? (
            <Button onClick={onToggleEdit} className="btn-secondary" data-testid="care-team-edit-btn">
              <Edit size={16} className="mr-2" />
              Edit
            </Button>
          ) : (
            <Button onClick={onCancelEdit} className="btn-ghost text-red-600" data-testid="care-team-cancel-btn">
              <X size={16} className="mr-2" />
              Cancel
            </Button>
          )}
        </div>

        {!isEditing ? (
          <div className="space-y-2">
            {editedData.care_team?.map((member, index) => (
              <div key={index} className="p-3 bg-white rounded-lg border border-blue-200">
                <p className="font-semibold text-slate-900">{member.name}</p>
                <p className="text-sm text-slate-600">{member.role}</p>
              </div>
            ))}
            {(!editedData.care_team || editedData.care_team.length === 0) && (
              <p className="text-slate-500 italic">No care team members assigned</p>
            )}
          </div>
        ) : (
          <CareTeamEditor
            careTeam={editedData.care_team || []}
            onChange={onCareTeamChange}
          />
        )}
      </div>
    </div>
  );
};

export default CareTeamSection;
